export default "__VITE_ASSET__59edf0f2__"